<template>
    <a class="text-link" :href="link.href">{{ link.text }}</a>
</template>

<script>
export default {
    name: "TextLink",
    props: {
        link: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.text-link {
    color: #4858cf;
    text-decoration: none;
    font-weight: 400;
    font-size: 1rem;
    cursor: pointer;
}
</style>